var map = {
	"./about-lenses/about-benefits.scss": "../css/components/about-lenses/about-benefits.scss",
	"./adjustable-page.scss": "../css/components/adjustable-page.scss",
	"./article-content-list.scss": "../css/components/article-content-list.scss",
	"./article-top-main-banner.scss": "../css/components/article-top-main-banner.scss",
	"./back-btn-text.scss": "../css/components/back-btn-text.scss",
	"./base-cards-list.scss": "../css/components/base-cards-list.scss",
	"./base-dot-list.scss": "../css/components/base-dot-list.scss",
	"./border-badges.scss": "../css/components/border-badges.scss",
	"./breadcrumb.scss": "../css/components/breadcrumb.scss",
	"./breadcrumbs.scss": "../css/components/breadcrumbs.scss",
	"./button-tabs.scss": "../css/components/button-tabs.scss",
	"./call-center/call-center-modals.scss": "../css/components/call-center/call-center-modals.scss",
	"./call-center/call-center-table.scss": "../css/components/call-center/call-center-table.scss",
	"./call-center/cancel-order-modal.scss": "../css/components/call-center/cancel-order-modal.scss",
	"./call-center/change-optic-modal.scss": "../css/components/call-center/change-optic-modal.scss",
	"./call-center/index.scss": "../css/components/call-center/index.scss",
	"./call-center/order-action-modal.scss": "../css/components/call-center/order-action-modal.scss",
	"./cards-steps.scss": "../css/components/cards-steps.scss",
	"./cart-notification/index.scss": "../css/components/cart-notification/index.scss",
	"./catalog/catalog-item.scss": "../css/components/catalog/catalog-item.scss",
	"./club/club-locator.scss": "../css/components/club/club-locator.scss",
	"./club/club-privilege.scss": "../css/components/club/club-privilege.scss",
	"./club/invite-friend-club-form.scss": "../css/components/club/invite-friend-club-form.scss",
	"./club/invite-friend.scss": "../css/components/club/invite-friend.scss",
	"./confirm-modal.scss": "../css/components/confirm-modal.scss",
	"./control/button.scss": "../css/components/control/button.scss",
	"./control/link-dot.scss": "../css/components/control/link-dot.scss",
	"./control/search-control.scss": "../css/components/control/search-control.scss",
	"./control/tabs.scss": "../css/components/control/tabs.scss",
	"./control/tag.scss": "../css/components/control/tag.scss",
	"./dashed-list.scss": "../css/components/dashed-list.scss",
	"./detail-materials/detail-material-rating.scss": "../css/components/detail-materials/detail-material-rating.scss",
	"./dotted-list.scss": "../css/components/dotted-list.scss",
	"./email-confirm-modal.scss": "../css/components/email-confirm-modal.scss",
	"./footnote.scss": "../css/components/footnote.scss",
	"./hcp/ask-expert-form.scss": "../css/components/hcp/ask-expert-form.scss",
	"./hcp/specialists-pro-page.scss": "../css/components/hcp/specialists-pro-page.scss",
	"./hidden-items.scss": "../css/components/hidden-items.scss",
	"./icon-status.scss": "../css/components/icon-status.scss",
	"./input/input-text-field.scss": "../css/components/input/input-text-field.scss",
	"./input/input.scss": "../css/components/input/input.scss",
	"./lenses-put-take.scss": "../css/components/lenses-put-take.scss",
	"./lenses/components/l-cards.scss": "../css/components/lenses/components/l-cards.scss",
	"./lenses/components/l-tabs.scss": "../css/components/lenses/components/l-tabs.scss",
	"./lenses/myths-and-facts.scss": "../css/components/lenses/myths-and-facts.scss",
	"./lenses/types-lenses-and-solutions.scss": "../css/components/lenses/types-lenses-and-solutions.scss",
	"./library-link/library-link.scss": "../css/components/library-link/library-link.scss",
	"./list-bullet.scss": "../css/components/list-bullet.scss",
	"./list-check.scss": "../css/components/list-check.scss",
	"./list-counter.scss": "../css/components/list-counter.scss",
	"./modal-chatbot.scss": "../css/components/modal-chatbot.scss",
	"./modal-check/index.scss": "../css/components/modal-check/index.scss",
	"./numbered-title.scss": "../css/components/numbered-title.scss",
	"./ny-lottery/ny-lotter.scss": "../css/components/ny-lottery/ny-lotter.scss",
	"./ny-lottery/popup.scss": "../css/components/ny-lottery/popup.scss",
	"./online-partners.scss": "../css/components/online-partners.scss",
	"./order-precision-one/index.scss": "../css/components/order-precision-one/index.scss",
	"./order-precision-one/order-precision-one-table.scss": "../css/components/order-precision-one/order-precision-one-table.scss",
	"./ozon-modal.scss": "../css/components/ozon-modal.scss",
	"./product/precision/consumer.scss": "../css/components/product/precision/consumer.scss",
	"./product/precision/specialist.scss": "../css/components/product/precision/specialist.scss",
	"./product/precision/try-precision.scss": "../css/components/product/precision/try-precision.scss",
	"./product/product-pdf-file.scss": "../css/components/product/product-pdf-file.scss",
	"./product/product-review-application-modal.scss": "../css/components/product/product-review-application-modal.scss",
	"./product/product-reviews-block.scss": "../css/components/product/product-reviews-block.scss",
	"./pronews/pronews.scss": "../css/components/pronews/pronews.scss",
	"./pronews/ssg-calculator.scss": "../css/components/pronews/ssg-calculator.scss",
	"./quotes-item.scss": "../css/components/quotes-item.scss",
	"./radio-checkbox.scss": "../css/components/radio-checkbox.scss",
	"./rating-stars.scss": "../css/components/rating-stars.scss",
	"./redesign-components.scss": "../css/components/redesign-components.scss",
	"./search.scss": "../css/components/search.scss",
	"./share/share-snippet.scss": "../css/components/share/share-snippet.scss",
	"./spend-points/table.scss": "../css/components/spend-points/table.scss",
	"./sre-list.scss": "../css/components/sre-list.scss",
	"./star-rating-general.scss": "../css/components/star-rating-general.scss",
	"./vue-datepicker.scss": "../css/components/vue-datepicker.scss",
	"./vue-select/global/_animations.scss": "../css/components/vue-select/global/_animations.scss",
	"./vue-select/global/_component.scss": "../css/components/vue-select/global/_component.scss",
	"./vue-select/global/_states.scss": "../css/components/vue-select/global/_states.scss",
	"./vue-select/global/_variables.scss": "../css/components/vue-select/global/_variables.scss",
	"./vue-select/modules/_clear.scss": "../css/components/vue-select/modules/_clear.scss",
	"./vue-select/modules/_dropdown-menu.scss": "../css/components/vue-select/modules/_dropdown-menu.scss",
	"./vue-select/modules/_dropdown-option.scss": "../css/components/vue-select/modules/_dropdown-option.scss",
	"./vue-select/modules/_dropdown-toggle.scss": "../css/components/vue-select/modules/_dropdown-toggle.scss",
	"./vue-select/modules/_open-indicator.scss": "../css/components/vue-select/modules/_open-indicator.scss",
	"./vue-select/modules/_search-input.scss": "../css/components/vue-select/modules/_search-input.scss",
	"./vue-select/modules/_selected.scss": "../css/components/vue-select/modules/_selected.scss",
	"./vue-select/modules/_spinner.scss": "../css/components/vue-select/modules/_spinner.scss",
	"./vue-select/vue-select.scss": "../css/components/vue-select/vue-select.scss",
	"./vuejs-datepicker.scss": "../css/components/vuejs-datepicker.scss",
	"./wearing-and-care/block-img-r.scss": "../css/components/wearing-and-care/block-img-r.scss"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../css/components sync recursive \\.scss$";